/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-undef */
import styled from 'styled-components';

import Button from '../styles';
import { ButtonSizes } from '../Enum';
import { IButtonSpinner } from './index';

export const ButtonSpinnerLoaderComponent = styled(Button)<IButtonSpinner>`
  height: ${({ size }) => size}px;
  padding: 0px
    ${({ isLoading, size }) => {
      if (isLoading) return size === ButtonSizes.SMALL ? 4 : 9;

      return size === ButtonSizes.SMALL ? 7 : 15;
    }}px;

  &:disabled {
    background: ${({ isLoading, color, theme }) =>
      isLoading ? color : theme.colors.disabled};
    border: 1px solid
      ${({ isLoading, color, theme }) =>
        isLoading ? color : theme.colors.disabled};
    cursor: default;
  }

  svg {
    width: ${({ size }) => (size === ButtonSizes.SMALL ? 18 : 20)}px;
    height: ${({ size }) => (size === ButtonSizes.SMALL ? 18 : 20)}px;
  }

  svg > .path {
    stroke: ${({ theme, color }) =>
      color === theme.colors.tertiary
        ? theme.colors.primary
        : theme.colors.white};
  }
`;
